export default "__VITE_ASSET__DT1vp7wB__"